export const featureFlagsKnowledgeBase:Record<string, boolean> = {
  
}
